import { useEffect, type ReactNode } from "react";
import { X } from "lucide-react";

export function Modal({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4"
      onClick={onClose}
    >
      <div
        role="dialog"
        className="max-h-[85vh] w-full max-w-2xl overflow-auto rounded-xl border border-line bg-bg-1 p-5 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="mb-3 flex items-center justify-between gap-4">
          <h2 className="truncate text-lg font-semibold text-ink-1">{title}</h2>
          <button onClick={onClose} aria-label="Закрыть" className="text-ink-2 hover:text-ink-1">
            <X size={18} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
